export default __webpack_public_path__ + "static/media/Astro_Aquarius_Black.28c6c3b3.png";